import { useJobList, useJobListForUser } from "../../../../common/hooks/api/job";

export const useJobListByRole = (isAdmin) => isAdmin ? useJobList : useJobListForUser;
